import React from 'react';
import { Form, Input } from 'antd';

const Email = ({ form, disabled }) => {
  const { getFieldDecorator } = form;

  return (
    <div className="offer-card__item">
      <span className="label">E-mail:</span>
      <Form.Item>
        {getFieldDecorator('email')(
          <Input style={{ width: 368 }} disabled={disabled} />
        )}
      </Form.Item>
    </div>
  );
};

export default Email;
